import $ from 'jquery';



/* Site search
********************************************/

$('.js-main-search-toggle').on('click', function (e) {
	e.preventDefault();
	$('.js-main-search').toggleClass('is-active');
	$('.js-main-search .c-page-search__field').trigger('focus');
});
$(document).on('click', function (e) {
	if (!$(e.target).closest('.js-main-search').length) {
		$('.js-main-search').removeClass('is-active');
	}
});
